import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Database } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/admin/data/redis')({
  component: RedisViewerPage,
});

function RedisViewerPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Redis Viewer</h1>
        <p className="text-muted-foreground">Browse and query Redis cache</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Database className="h-5 w-5" />
            Redis
          </CardTitle>
          <CardDescription>Cache browser and query interface</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Redis viewer coming soon...</p>
        </CardContent>
      </Card>
    </div>
  );
}
